import Vue from "vue";

export const PaginationEventBus = new Vue();
